/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createRoleFromDiscriminatorValue, type Role } from '../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /AllotmentRole
 */
export interface AllotmentRoleRequestBuilder extends BaseRequestBuilder<AllotmentRoleRequestBuilder> {
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<Role[]>}
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<Role[] | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const AllotmentRoleRequestBuilderUriTemplate = "{+baseurl}/AllotmentRole";
/**
 * Metadata for all the requests in the request builder.
 */
export const AllotmentRoleRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: AllotmentRoleRequestBuilderUriTemplate,
        responseBodyContentType: "text/plain;q=0.9",
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createRoleFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
